/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class DvsUpgradeLacpWizardManager {

      public static $inject = ["pageStateManagementService"];

      constructor(private pageStateManagementService: any) {
      }

      public init(wizardScope: DvsUpgradeWizardScope): void {
         this.pageStateManagementService
               .registerWizardForDefaultStateManagementStrategy(wizardScope);
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .service("dvsUpgradeLacpWizardManager", DvsUpgradeLacpWizardManager);
}
